import classnames from 'classnames';
import { TestRedeemed } from 'components/Redeem';
import { PageTitle } from 'components/misc';
import { Layout } from 'layouts';
import React from 'react';
import styles from './redeemed.module.scss';

export const ScreensTestRedeemed = (props) => {
  return (
    <Layout showBackButton={false}>
      <PageTitle title="Test Redeemed" />
      <div
        className={classnames('container', styles.container)}
        data-test-id="test-redeemed-wrapper"
        style={{ marginTop: '50px' }}
      >
        <TestRedeemed />
      </div>
    </Layout>
  );
};

ScreensTestRedeemed.propTypes = {};

export default ScreensTestRedeemed;
